import React from 'react';
import { Box, Typography, List, ListItem, Divider, Button, Grid } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

const OrderDetails: React.FC = () => {
  return (
    <Grid
      sx={{
        padding: '20px',
        backgroundColor: 'white',
        height: '100vh',
        maxWidth: '400px', // Adjust the width as per your preference
      }}
    >
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="h6" gutterBottom color={"darkmagenta"}>
          5 Salon 8
        </Typography>
        <WSIcons.AccountCircleIcon />
      </Grid>

      {/* Add margin to the List to create space below */}
      <List sx={{ marginBottom: '40px' }}>
        <Divider />
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>2x İşkembe Çorbası</Typography>
            <Typography>₺72,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>1x İstakoz Izgara</Typography>
            <Typography> ₺95,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
        {/* Additional List Items */}
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>1x İstakoz Izgara</Typography>
            <Typography> ₺95,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>1x İstakoz Izgara</Typography>
            <Typography> ₺95,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>1x İstakoz Izgara</Typography>
            <Typography> ₺95,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
        <ListItem>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: 1 }}>
            <Typography>1x İstakoz Izgara</Typography>
            <Typography> ₺95,00</Typography>
          </Grid>
        </ListItem>
        <Divider />
      </List>

      {/* Bottom box with payment button and total amount */}
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Button sx={{backgroundColor:"palegreen"}}>ODEME AL</Button>
        <Typography variant="h5">₺786,90</Typography>
      </Grid>
    </Grid>
  );
};

export default OrderDetails;
